import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deletePost } from '../services/postService';

interface DeletePostResponse {
  success: boolean;
  message?: string;
}

export const useDeletePost = () => {
  const queryClient = useQueryClient();
  
  return useMutation<DeletePostResponse, Error, string>({
    mutationFn: async (postId: string): Promise<DeletePostResponse> => {
      try {
        console.log(`🗑️ Deleting post ID: ${postId}`);
        const result = await deletePost(postId);
        
        if (!result.success) {
          throw new Error(result.message || 'Failed to delete post');
        }
        
        console.log('✅ Post deleted successfully');
        return result;
      } catch (error) {
        console.error('❌ Error deleting post:', error);
        throw error;
      }
    },
    onSuccess: () => {
      // Invalidate the posts query to refetch the list
      queryClient.invalidateQueries({ queryKey: ['posts'] });
    }
  });
}; 